/**
 * @file Constant.js
 * @desc 常量，包含接口路径，独立页面内公共常量
 * @author ~~
 * @data 2022/03/31
 */

const Const = {};
// 开发机环境
if (process.env.NODE_ENV === 'development') {
    Const.panoServer = 'http://gzns-streetview-dataproc01.gzns.baidu.com:8088/ugc/feed/';
    Const.server1 = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094/ugc/api/aroundlistmarks';
    Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094/ugc/mark/';

    // Const.panoServer = 'http://nj02-map-navi-routing-engine20-24.nj02.baidu.com:8986/ugc/feed/';
    // Const.server1 = 'http://nj02-map-navi-routing-engine20-24.nj02.baidu.com:8986/ugc/api/aroundlistmarks';
    // Const.server = 'http://nj02-map-navi-routing-engine20-24.nj02.baidu.com:8986/ugc/mark/';

    // Const.panoServer = 'http://yq01-aip-tianzhi352a1e55.yq01.baidu.com:8021/ugc/feed/';
    // Const.server1 = 'http://yq01-aip-tianzhi352a1e55.yq01.baidu.com:8021/ugc/api/aroundlistmarks';
    // Const.server = 'http://yq01-aip-tianzhi352a1e55.yq01.baidu.com:8021/ugc/mark/';

    // Const.server2 = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8888/';
    // Const.panoServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8221/ugc/feed/';
    // Const.panoServer = 'https://pai.baidu.com/ugc/feed/';
    // Const.server1 = 'https://pai.baidu.com/ugc/api/aroundlistmarks';
    // Const.server = 'https://pai.baidu.com/ugc/mark/';
    Const.server2 = 'https://pai.baidu.com/';
}
// QA环境
else if (process.env.NODE_ENV === 'test') {
    // Const.server = 'https://pai.baidu.com/';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8083/ugc/mark/';

}
// 线上环境
else {
    // Const.panoServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094/ugc/feed/';
    // Const.server1 = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094/ugc/api/aroundlistmarks';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094/ugc/mark/';

    Const.panoServer = 'https://pai.baidu.com/ugc/feed/';
    Const.server1 = 'https://pai.baidu.com/ugc/api/aroundlistmarks';
    Const.server = 'https://pai.baidu.com/ugc/mark/';
    Const.server2 = 'https://pai.baidu.com/';
    // Const.server1 = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8221/ugc/api/aroundlistmarks';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8221/ugc/mark/';
}

Const.dataUrl = {
    /**
     * 校验登录
     */
    checkLogin: {
        url: 'https://content.map.baidu.com/mapcjhactivity/activity/main/getheadphoto?fr=ugc_jingpin'
    },
    /**
     * 添加评论
     */
    addMark: {
        url: Const.server + 'addmark'
    },

    /**
   * 获取当前场景评论
   */
    getMark: {
        url: Const.server1
    },

    /**
   * 删除评论
   */
    delMark: {
        url: Const.server + 'delmark'
    },

    /**
   * 对某条评论点赞
   */
    voteMark: {
        url: Const.server + 'votemark'
    },

    /**
   * 获取回复列表
   */
    getReplyList: {
        url: Const.server + 'replyfeed'
    },

    /**
   * 回复评论
   */
    submitReply: {
        url: Const.server + 'replysubmit'
    },

    /**
   * 获取默认留言
   */
    getFastRecoms: {
        url: Const.server + 'getfastrecoms'
    },
    // 获取页面数据
    getPanoInfo: {
        isMock: 0,
        url: Const.panoServer + 'getfeed'
    },
    // 全景点赞+分享
    voteSharePano: {
        isMock: 0,
        url: Const.panoServer + 'updatefeednum'
    },
    // 反馈问题+音乐列表
    getfeedextral: {
        isMock: 0,
        url: Const.panoServer + 'getfeedextral'
    },
    // 提交反馈 post
    submitfeedback: '/api/pcpano/submitfeedback',

    // 全部留言
    allMessage: {
        url: Const.server + 'msgfeed'
    },

    // 主题页接口
    getFeedByTopic: {
        isMock: 0,
        url: Const.panoServer + 'getfeedbytopic'
    },

    // 主题页接口
    getTab: {
        isMock: 0,
        url: Const.panoServer + 'channellist'
    },
    // 搜索详情页
    getFeedDetail: {
        isMock: 0,
        url: Const.panoServer + 'getFeedDetail'
    },
    // 我的留言
    getMessageData: {
        isMock: 0,
        url: Const.server2 + 'ugc/mark/mymark'
    }

};

export default Const;
